import React from 'react';
import './Hero.css';

const Hero = ({ section }) => {
  // Apenas a imagem dinâmica fica inline

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const dynamicStyle = {
    position: 'relative',
    backgroundImage: section.background_image_url ? `url(${backendUrl}${section.background_image_url})` : 'none',
    backgroundColor: section.background_color || 'transparent',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };
  return (
    <section id={section.slug} className="hero-section bg-parallax" style={dynamicStyle}>
      {section.background_image_url && <div className="overlay"></div>}
      <div className="container text-center v-align">
        <h1 className="display-2 fw-bold text-white st_title fonte-secundaria">{section.title}</h1>
        <p className="fonte-terciaria lead text-white st_subtitle">{section.subtitle}</p>
        
      </div>
    </section>
  );
};

export default Hero;
